import { computed } from 'vue';
import { useRoute } from 'vue-router';

export function useTagSubSectionNav() {
  const route = useRoute();

  const subSectionNav = computed(() => {
    if (!route.params.id) return null;
    return [
      { to: { name: 'admin_tag_categories_edit', params: { id: route.params.id } }, label: 'Edit' },
      { to: { name: 'admin_tag_categories_edit_tags', params: { id: route.params.id } }, label: 'Manage Tags' },
    ];
  });

  return { subSectionNav };
}
